import { Div } from '@dnb/eufemia';
import type { JSX } from 'react';

import style from './index.module.css';

interface DotProps {
  right?: 'small' | 'medium' | 'large';
  left?: 'small' | 'medium' | 'large';
}
export default function Dot({ right, left }: DotProps): JSX.Element {
  return (
    <Div className={style['DotOuter']} left={left} right={right}>
      <Div className={style['Dot']} />
    </Div>
  );
}
